import React, { Component } from "react";
// import 'antd/dist/antd.css';
// import $ from "jquery";
// import NodeParaEditSD from "./NodeParaEditSD";
import { Row, Col, Modal, Button } from "antd";
// import { brotliDecompress } from "zlib";
// import {render} from 'react-dom'
// var jtopo = $('<script src="../../common/jtopo-0.4.8-min.js" type="text/javascript"></script>');
// $(document.body).before(jtopo);
const JTopo = window.JTopo;
const STARTNODETYPE = "01";
const contextmenu = [
    {
        text: "添加跳转",
        pk: "2",
        img: "./images/si/jump.png",
        func: function(wf) {
            wf.rmenuClick(wf, "02");
        }
    },
    {
        text: "添加服务",
        pk: "3",
        img: "./images/si/services.png",
        func: function(wf) {
            wf.rmenuClick(wf, "03");
        }
    },
    {
        text: "添加脚本",
        pk: "4",
        img: "./images/si/script.png",
        func: function(wf) {
            wf.rmenuClick(wf, "04");
        }
    },
    {
        text: "添加子流程",
        pk: "5",
        img: "./images/si/child.png",
        func: function(wf) {
            wf.rmenuClick(wf, "05");
        }
    },
    {
        text: "添加终点",
        pk: "6",
        img: "./images/si/end.png",
        func: function(wf) {
            wf.rmenuClick(wf, "99");
        }
    },
    {
        text: "删除节点",
        pk: "7",
        img: "./images/si/delete.png",
        func: function(wf) {
            let node = wf.state.currnode;
            if (!node) {
                alert("no selected node");
                return;
            }
            node.remove();
        }
    }
];
const startNodedata = {
    serviceid: null, // 服务接口描述
    servicecallin: [], // 从服务接口描述获取的输入参数列表
    servicecallout: [], // 服务接口描述服务输出参数列表
    serviceUrl: null, // 对外暴露的服务请求接口
    servicecalltype: "0", // 服务调用类型
    serviceAcynctype: "0", // 服务同步类型
    servicetimeout: 30, // 服务总超时时间
    serviceprotocol: "0", // 服务协议类型
    servicetimeoutHandling: "01", // 服务超时处理机制
    serviceredoTime: 0, // 服务重做次数
    serviceredoCycle: "01", // 服务重做周期
    servicecallbackUrl: "" // 服务撤销处理请求接口
};

const serviceNodedata = {
    // 服务节点
    servicecallin: [], // 服务输入参数列表
    servicecallout: [], // 服务输入参数列表
    servicecallMapping: [], // 服务报文映射
    serviceUrl: null,
    servicecalltype: "0", // 同异步类型
    serviceAcynctype: "0", // 异步处理方式  0-回调接口  1-消息订阅
    servicetimeout: 30,
    serviceprotocol: "0", // 通讯协议
    servicetimeoutHandling: "01", // 超时处理机制
    serviceredoTime: 0, // 重试次数
    serviceredoCycle: "01", // 重试周期
    servicecallbackUrl: "" // 回调接口
};
const scriptNodedata = {
    // 脚本节点
    scripttype: "0", // 默认脚本类型为JavaScript
    scriptcode: "", // 脚本内容
    scriptcallin: [], // 服务输入参数列表
    scriptcallout: [] // 回调接口服务输入参数列表
};

class ServiceInterface extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editpanelWidth: 24, // 节点编辑面板宽度-目前使用抽屉编辑界面
            root: undefined, // 根节点
            over: undefined, // 结束节点
            w:
        this.props.width !== null && typeof this.props.width !== "undefined"
            ? this.props.width
            : "100%", // 当前编辑界面宽度
            h:
        this.props.height !== null && typeof this.props.height !== "undefined"
            ? this.props.height
            : "790px", // 当前编辑界面高度
            canvas: undefined, // 绘制对象
            code:
        this.props.code !== null && typeof this.props.code !== "undefined"
            ? this.props.code
            : "SIEditPanel", // 当前编辑界面id
            canvasid:
        this.props.code !== null && typeof this.props.code !== "undefined"
            ? "canvas" + this.props.code
            : "canvasSIEditPanel", // 当前绘制界面id
            editid:
        this.props.code !== null && typeof this.props.code !== "undefined"
            ? "editid" + this.props.code
            : "canvasSIeditidPanel", // 当前绘制界面id
            currnode: null, // 当前节点
            currdata: null, // 当前节点数据
            maxid: 1, // 节点序号使用
            contextmenu:
        this.props.ctxmenu !== null && typeof this.props.ctxmenu !== "undefined"
            ? this.props.ctxmenu
            : contextmenu,
            // 自定义点击事件
            clickfunction:
        this.props.clickFunc !== null &&
        typeof this.props.clickFunc !== "undefined"
            ? this.props.clickFunc
            : this.clickFunc,
            // 自定义空白处点击事件
            blankClickFunc:
        this.props.blankClickFunc !== null &&
        typeof this.props.blankClickFunc !== "undefined"
            ? this.props.blankClickFunc
            : this.blankClickFunc,
            // 数据模型
            model:
        this.props.model !== null && typeof this.props.model !== "undefined"
            ? this.props.model
            : null,
            // 是否可编辑
            readOnly:
        this.props.readOnly !== null &&
        typeof this.props.readOnly !== "undefined"
            ? this.props.readOnly
            : true,
            // 调试标志
            debug:
        this.props.debug !== null && typeof this.props.debug !== "undefined"
            ? this.props.debug
            : false,
            objFct: this.props.objFct,
            uids:
        this.props.uids !== null && typeof this.props.uids !== "undefined"
            ? this.props.uids
            : []
        };
    }
    clickfunction(node, model) {
        let me = this;
        if (node.type !== STARTNODETYPE) {
            me.setState({ editpanelWidth: 18 });
        } else {
            me.setState({ editpanelWidth: 24 });
        }
    }
    sceneClickFcuntion() {
    // 界面点击方法
    }
    init() {
        let baseDom = document.getElementById(this.state.canvasid);
        let editpanel = document.getElementById(this.state.editid);
        baseDom.width = editpanel.clientWidth;
        baseDom.height = editpanel.clientHeight;
        this.canvas = this.scene(baseDom);
        if (this.state.model) {
            if (!this.maxid) {
                this.maxid = 0;
            }
            this.drawRoot(this.state.model, this.state.readOnly);
            this.maxid++;
        } else {
            if (!this.maxid) {
                this.maxid = 1;
            }
            let start = this.newData(null, STARTNODETYPE);
            this.drawRoot(start);
        }
    }
    // 绘制画布
    scene(domNode) {
        let me = this;
        let stage = new JTopo.Stage(domNode); // 创建一个舞台对象
        let scene = new JTopo.Scene(stage); // 创建一个场景对象
        stage.wheelZoom = 0.9;
        scene.mode = "normal";
        if (me.readOnly) {
            stage.mode = "drag";
        }
        stage.wheelZoom = null;
        stage.click((event) => {
            // 关闭弹出菜单（div）
            me._hideMenu("ctxmenu");
            if (!me.nodeclick) {
                // 标识这次执行的是空白处的点击事件
                me.sceneClickFcuntion();
            }
            me.nodeclick = false;
        });
        return scene;
    }
    // 绘制流程图
    drawRoot(model, type) {
        let me = this;
        if (!this.canvas) {
            me.init();
        }
        // this.root:model});
        let jumps = [];
        let nodes = [];
        var draw = function(model) {
            if (!model) {
                return;
            }
            let node = me.getnode(model, model.type, type);
            if (model.type === STARTNODETYPE) {
                // me.root=node;
                // me.currnode=node;
                me.setState({ root: node, currnode: node });
            }
            if (!node) {
                tool.sgiLogger.log("create node failed," + model);
                return undefined;
            }
            nodes.push(node);
            me.canvas.add(node);
            let children = model.childNode;
            if (!children) {
                if (model.type === "02") {
                    jumps.push(node);
                }
                if (!me.maxid) {
                    me.maxid = 0;
                }
                if (node.data.id > me.maxid) {
                    me.maxid = node.data.id;
                }
                tool.sgiLogger.log(model.name + " no children");
                return node;
            }
            let downnodes = [];
            for (let i = 0; i < children.length; i++) {
                let n = draw(children[i]);
                if (n) {
                    if (!n.parentsNode) {
                        n.parentsNode = [];
                    }
                    n.parentsNode.push(node);
                    downnodes.push(n);
                }
            }
            node.to = downnodes;
            for (let j = 0; j < downnodes.length; j++) {
                let link = me.line(node, downnodes[j]);
                if (link) {
                    me.canvas.add(link);
                }
            }
            if (!me.maxid) {
                me.maxid = 0;
            }
            if (node.data.id > me.maxid) {
                me.maxid = node.data.id;
            }
            // if (node.data.type==="02") jumps.push(node);
            return node;
        };
        let node = draw(model);
        for (let n = 0; n < jumps.length; n++) {
            let jpnode = jumps[n];
            for (let m = 0; m < nodes.length; m++) {
                tool.sgiLogger.log(nodes[m].id);
                if (jpnode.data.ncode === nodes[m].data.id) {
                    let link = me.dottedline(jpnode, nodes[m]);
                    jpnode.dotline = link;
                    me.canvas.add(link);
                    break;
                }
            }
        }
        return node;
    }
    clear() {
        if (this.canvas) {
            this.canvas.clear();
        }
    }
    // 根据数据创建节点
    create(currentNode, model) {
        if (!model) {
            return;
        }
        let me = this;
        if (!this.canvas) {
            me.init();
        }
        let node = me.getnode(model, model.type);
        if (model.type === STARTNODETYPE) {
            // me.root = node
            // me.currnode = node
            me.setState({ root: node, currnode: node });
        }
        if (!node) {
            tool.sgiLogger.log("unsupport node type : " + model.type);
            return;
        }
        if (currentNode && node) {
            me.canvas.add(node);
            let link = me.line(currentNode, node);
            me.canvas.add(link);
        }
        return node;
    }
    remove(node) {
        let me = this;

        if (node.data && node.data.type && node.data.type === "02") {
            let dotline = node.dotline;
            if (me.canvas && dotline) {
                me.canvas.remove(dotline);
            }
            if (dotline && dotline.nodeA && dotline.nodeA.type === "temp") {
                me.canvas.remove(dotline.nodeA);
            }

            if (dotline && dotline.nodeZ && dotline.nodeZ.type === "temp") {
                me.canvas.remove(dotline.nodeZ);
            }
        }
        if (me.canvas) {
            if (node.fromlines && node.fromlines.length > 0) {
                node.fromlines.forEach((line) => {
                    if (line && line.nodeA && line.nodeA.type === "temp") {
                        me.canvas.remove(line.nodeA);
                        me.canvas.remove(line);
                    }

                    if (line && line.nodeZ && line.nodeZ.type === "temp") {
                        me.canvas.remove(line.nodeZ);
                        me.canvas.remove(line);
                    }
                });
            }

            if (node.tolines && node.tolines.length > 0) {
                node.tolines.forEach((line) => {
                    if (line && line.nodeA && line.nodeA.type === "temp") {
                        me.canvas.remove(line.nodeA);
                        me.canvas.remove(line);
                    }

                    if (line && line.nodeZ && line.nodeZ.type === "temp") {
                        me.canvas.remove(line.nodeZ);
                        me.canvas.remove(line);
                    }
                });
            }

            me.canvas.remove(node);
        }
    }

    line(fromNode, toNode) {
        let me = this;
        let line = new JTopo.Link(fromNode, toNode);

        line.lineWidth = 1; // 线宽
        line.arrowsRadius = 5; // 箭头大小
        line.textOffsetY = 3; // 文本偏移量(向下3个像素)
        line.strokeColor = "192,192,192";
        // line.bundleOffset = 60; // 折线拐角处的长度
        // line.bundleGap = 20; // 线条之间的间隔

        fromNode.setToline(line);
        toNode.setFromline(line);

        if (!me.state.readOnly) {
            line.addEventListener("dbclick", function(e) {
                // var anode = this.nodeA;
                // var tempstart = me.lineStartNode(anode.x, anode.y, this);

                let anode = this.nodeA;
                let znode = this.nodeZ;

                if (
                    znode &&
          line.nodeZ.type !== "temp" &&
          anode &&
          line.nodeA.type !== "temp"
                ) {
                    let tempstart = me.lineEndNode(znode.x - 35, znode.y, this);
                    me.canvas.add(tempstart);
                    for (let i = 0; i < anode.tolines.length; i++) {
                        if (
                            anode.tolines[i].nodeA === anode &&
              anode.tolines[i].nodeZ === tempstart
                        ) {
                            // anode.tolines[i].nodeZ = tempstart;
                            if (anode.data.childNode) {
                                anode.data.childNode.splice(i, 1);
                            }
                        }
                    }
                    for (let i = 0; i < znode.fromlines.length; i++) {
                        if (
                            znode.fromlines[i].nodeA === anode &&
              znode.fromlines[i].nodeZ === tempstart
                        ) {
                            // anode.tolines[i].nodeZ = tempstart;
                            znode.fromlines.splice(i, 1);
                        }
                    }
                }
            });
        }

        return line;
    }
    dottedline(fromNode, toNode) {
        let link = this.line(fromNode, toNode);
        link.dashedPattern = 5; // 虚线
        return link;
    }
    lineStartNode(x, y, line) {
        let me = this;
        let lsn = me._tempNode(x, y);

        line.nodeA = lsn;
        lsn.toline = line;

        return lsn;
    }
    lineEndNode(x, y, line) {
        let me = this;
        let len = me._tempNode(x, y);

        line.nodeZ = len;
        len.fromline = line;

        return len;
    }
    jumpLine(node) {
        let me = this;
        let temp = me._tempNode(node.x + 130, node.y + 30);
        temp.addEventListener("mousedrag", function(e) {
            // me.dragnode = this;
            me.setState({ dragnode: this });
        });
        let dotline = me.dottedline(node, temp);

        dotline.nodeZ = temp;
        temp.fromline = dotline;

        this.canvas.add(temp);
        this.canvas.add(dotline);

        node.dotline = dotline;

        return dotline;
    }
    _addNodeListener(node) {
        let me = this;
        node.addEventListener("click", (e) => {
            // if (!me.nodedrag) {
            //     me.state.clickfunction(node, me);
            //     me.nodeclick = true; // 标识这次执行的是node的点击事件
            // }
            // me.nodedrag = false;
        });
        node.addEventListener("dbclick", (e) => {
            me.state.clickfunction(node, me);
        });
        node.addEventListener("mouseup", function(e) {
            if (e.button === 2) {
                // 右键
                me.rclickFunc(node);
                me._showMenu(this, "ctxmenu");
            }
        });
        node.addEventListener("mousedown", (e) => {
            // tool.sgiLogger.log("mousedown:"+this);
        });
        node.addEventListener("mouseover", function(e) {
            if (me.state.dragnode) {
                let current = this;
                let temp = me.state.dragnode;
                let line;
                if (temp.toline) {
                    line = temp.toline;
                    // var downNode = line.nodeZ;
                    let tonode = line.nodeZ;
                    if (tonode && tonode.type !== "temp") {
                        // var childnodes = current.data.cldSet;

                        for (let i = 0; i < tonode.fromlines.length; i++) {
                            if (
                                tonode.fromlines[i].nodeA === current &&
                tonode.fromlines[i].nodeZ === tonode
                            ) {
                                return;
                            }
                        }

                        current.setToline(line);
                        var childnodes = current.data.childNode;
                        if (!childnodes) {
                            childnodes = [];
                            // current.data.cldSet = childnodes;
                            current.data.childNode = childnodes;
                        }
                        childnodes.push(tonode.data);
                    }
                } else {
                    line = temp.fromline;
                    let upNode = line.nodeA;
                    if (current === upNode) {
                        return;
                    }
                    for (let i = 0; i < upNode.tolines.length; i++) {
                        if (
                            upNode.tolines[i].nodeA === upNode &&
              upNode.tolines[i].nodeZ === current
                        ) {
                            return;
                        }
                    }
                    for (let i = 0; i < current.fromlines.length; i++) {
                        if (
                            current.fromlines[i].nodeA === upNode &&
              current.fromlines[i].nodeZ === current
                        ) {
                            return;
                        }
                    }
                    current.setFromline(line);
                    if (upNode && upNode.type !== "temp" && upNode.data.type !== "02") {
                        let childnodes = upNode.data.childNode;
                        if (childnodes) {
                            childnodes.push(current.data);
                        }

                        // upNode.data.gotoNodeId = current.data.id;
                        // upNode.data.ncode = current.data.id;
                    }
                    if (upNode && upNode.type !== "temp" && upNode.data.type === "02") {
                        upNode.data.gotoNodeId = current.data.id;
                        upNode.data.ncode = current.data.id;
                        upNode.click();
                        // me.refs.NodeParaEditSD.refs.jumppanel.setFieldsValue({
                        //   ncode: upNode.data.ncode
                        // });
                    }
                    // upNode.data.transfer = current.data.sc ;
                }
                me.remove(temp);
                me.setState({ dragnode: undefined });
            }
        });
        node.addEventListener("mousedrag", function(e) {
            if (this.data) {
                if (this.data.x !== this.x || this.data.y !== this.y) {
                    me.setState({ nodedrag: true });
                }
                this.data.x = this.x;
                this.data.y = this.y;
            }
        });
    }
    _setModelPubFiedls(model, node) {
        let me = this;
        node.data = model;
        node.createNextNode = function(data) {
            return me.create(this, data);
        };
        node.remove = function() {
            let delNode = this;
            let downlines = delNode.tolines;
            if (downlines) {
                for (let i = 0; i < downlines.length; i++) {
                    let line = downlines[i];
                    let tempstart = me.lineStartNode(delNode.x, delNode.y, line);
                    me.canvas.add(tempstart);
                }
            }
            delNode.tolines = [];

            if (typeof me.state.over !== "undefined" && delNode.type === "99") {
                me.setState({ over: undefined });
            }
            me.remove(delNode);
            let pnodes = delNode.parentsNode;
            if (pnodes) {
                for (let j = 0; j < pnodes.length; j++) {
                    if (pnodes[j].data.childNode) {
                        for (let i = 0; i < pnodes[j].data.childNode.length; i++) {
                            if (pnodes[j].data.childNode[i].id === delNode.data.id) {
                                pnodes[j].data.childNode.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
                for (let j = 0; j < pnodes.length; j++) {
                    let downlines = pnodes[j].tolines;
                    if (downlines) {
                        for (var i = 0; i < downlines.length; i++) {
                            var line = downlines[i];
                            if (line.nodeZ === delNode) {
                                pnodes[j].tolines.splice(i, 1);
                            }
                        }
                    }
                }
            }
        };
        node.setToline = function(line) {
            if (!this.tolines) {
                this.tolines = [];
            }
            this.tolines.push(line);

            line.nodeA = this;
        };
        node.setFromline = function(line) {
            if (!this.fromlines) {
                this.fromlines = [];
            }
            this.fromlines.push(line);

            line.nodeZ = this;
        };
        node.getChart = function() {
            return me;
        };

        node.id = model.sc;
    }
    getnode(model, nodetype, type) {
        let nodetypes = [STARTNODETYPE, "02", "03", "04", "05", "06", "99"];
        if (nodetypes.indexOf(nodetype) < 0) {
            return null;
        }
        let name;
        switch (nodetype) {
            case STARTNODETYPE:
                name = "开始";
                break;
            case "02":
                name = "跳转节点";
                break;
            case "03":
                name = "服务节点";
                break;
            case "04":
                name = "脚本节点";
                break;
            case "05":
                name = "子流程";
                break;
            case "06":
                name = "任务节点";
                break;
            case "99":
                name = "结束";
                break;

            default:
                break;
        }
        let node = new JTopo.Node(model.id + " " + name);
        if (!node) {
            return node;
        }
        // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
        node.font = "12px Consolas";
        node.textPosition = "Middle_Center"; // 文字居中
        node.fontColor = "0 ,0 ,0";
        // node.borderRadius = 5; // 圆角
        node.borderWidth = "1"; // 边框的宽度
        node.borderColor = "255,255,255"; // 边框颜色
        node.alpha = 0.9; // 透明度
        // node.textPosition = "Middle_Center";
        // node.setSize(58, 58);
        if (nodetype) {
            node.type = nodetype;
        }
        if (!model.name) {
            model.name = name;
        }
        if (nodetype === STARTNODETYPE || nodetype === "99") {
            node.beginDegree = 0;
            node.width = node.height = 80;
            node.paint = function(g) {
                g.beginPath();
                g.moveTo(0, 0);
                g.fillStyle = "rgba(255,140,0," + this.alpha + ")";
                g.arc(
                    0,
                    0,
                    this.width / 2,
                    this.beginDegree,
                    this.beginDegree + 2 * Math.PI
                );
                g.fill();
                g.closePath();

                g.save();
                g.beginPath();
                g.fillStyle = "rgba(255,239,213," + this.alpha + ")";
                g.moveTo(0, 0);
                g.arc(
                    0,
                    0,
                    this.width / 2 - 2,
                    this.beginDegree,
                    this.beginDegree + 2 * Math.PI
                );
                g.fill();
                g.closePath();
                g.restore();

                this.paintText(g);
            };

            // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
            node.font = "12px Consolas";
            node.textPosition = "Middle_Center"; // 文字居中
            node.fontColor = "0 ,0 ,0";
            // node.setSize(58, 58);
            if (nodetype) {
                node.type = nodetype;
            }
            if (!model.name) {
                model.name = name;
            }
            node.radius = 50; // 半径
            node.borderColor = "255,140,0"; // 边框颜色
            node.fillColor = "	255,239,213"; // 边框颜色
            // node.setImage(require('./images/start.png'));
            if (nodetype === "99") {
                this.setState({ over: node });
            }
        } else {
            node.borderWidth = 1; // 边框的宽度
            node.setText = function(str) {
                if (!str) {
                    this.text = name;
                }
                this.text = str;
            };
            if (model && model.name) {
                node.setText(model.id + " " + model.name);
            }
            if (nodetype === "02") {
                // node.fillColor = '255 ,255 ,0';
                node.setSize(70, 70);
                // node.rotate=45*Math.PI/180;
                node.borderRadius = 5; // 圆角
                node.fillColor = "127,255,170";
                node.borderColor = "50,205,50"; // 边框颜色
                // node.setImage(require('./images/jump_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/jump_undo.png"));
                    node.fillColor = "119 136 153";
                    node.borderColor = "105 105 105";
                } else if (model && model.status && model.status === "02") {
                    node.fontColor = "30 144 255";
                }
            }
            if (nodetype === "03") {
                node.setSize(100, 60);
                node.borderRadius = 5; // 圆角
                node.fillColor = "250,128,114";
                node.borderColor = "255,0,0"; // 边框颜色
                // node.setImage(require('./images/service_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/service_undo.png"));
                    node.fillColor = "119 136 153";
                    node.borderColor = "105 105 105";
                } else if (model && model.status && model.status === "02") {
                    node.fontColor = "30 144 255";
                }
            }
            if (nodetype === "04") {
                node.fillColor = "250 ,235 ,215";
                node.setSize(100, 60);
                node.borderRadius = 27; // 圆角
                node.fillColor = "255,20,147";
                node.borderColor = "255,215,0"; // 边框颜色
                // node.setImage(require('./images/script_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/script_undo.png"));
                    node.fillColor = "119 136 153";
                    node.borderColor = "105 105 105";
                } else if (model && model.status && model.status === "02") {
                    node.fontColor = "30 144 255";
                }
            }

            if (nodetype === "05") {
                node.fillColor = "188 ,143 ,143";
                node.setSize(110, 60);
                node.borderRadius = 30; // 圆角
                node.fillColor = "	221,160,221";
                node.borderColor = "148,0,211"; // 边框颜色
                // node.setImage(require('./images/workflow_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/workflow_undo.png"));
                    node.fillColor = "119 136 153";
                    node.borderColor = "105 105 105";
                } else if (model && model.status && model.status === "02") {
                    node.fontColor = "30 144 255";
                }
            }
            if (nodetype === "06") {
                // node.fillColor = "135 206 250";
                node.setSize(100, 60);
                node.borderRadius = 20; // 圆角
                node.fillColor = "142,229,238";
                node.borderColor = "30,144,255"; // 边框颜色
                // node.setImage(require("./images/task_done.png"));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/task_undo.png"));
                    node.fillColor = "119 136 153";
                    node.borderColor = "105 105 105";
                } else if (model && model.status && model.status === "02") {
                    node.fontColor = "30 ,144 ,255";
                }
            }
        }

        node.setLocation(model.x, model.y);
        this._setModelPubFiedls(model, node);
        if (!type) {
            this._addNodeListener(node);
        } else {
            // 当前执行节点  加特殊标识
            if (model && model.status) {
                node.percent = 0.8;
                node.beginDegree = 0;
                if (model.status === "01" || model.status === "99") {
                    if (model.status === "01") {
                        node.color = "rgba(0,255,0,";
                    }
                    if (model.status === "99") {
                        node.color = "rgba(255,0,0,";
                    }
                    // if (model.status === "03") node.color='rgba(143,153,159,';
                    // if (model.status === "04") node.color='rgba(245,255,0,' ;
                    // if (model.status === "05") node.color='rgba(244,248,244,';
                    // if (model.status === "02") node.color='rgba(30 ,144 ,255,' ;
                    if (model.status !== "01") {
                        node.percent = 1;
                    } else {
                        node.percent = 0.1;
                    }
                    node.paint = function(g) {
                        //
                        g.save();
                        g.beginPath();
                        g.moveTo(0, 0);
                        g.strokeStyle = this.color + this.alpha + ")";
                        g.lineWidth = 6;
                        g.arc(
                            0,
                            0,
                            (this.width + 3) / 2,
                            this.beginDegree,
                            this.beginDegree + 2 * Math.PI * this.percent
                        );
                        // g.fill();
                        g.stroke();
                        g.closePath();
                        g.beginPath();
                        g.moveTo(0, 0);
                        g.drawImage(this.image, -this.width / 2, -this.height / 2, 38, 38);
                        // g.fillStyle = 'rgba(0,0,255,' + this.alpha + ')';
                        // g.moveTo(0,0);
                        // g.arc(0, 0, this.width/2-8, this.beginDegree, this.beginDegree + 2*Math.PI);
                        // g.fill();
                        g.closePath();
                        g.restore();
                        this.paintText(g);
                    };
                    if (model.status === "01") {
                        JTopo.Animate.stepByStep(
                            node,
                            {
                                percent: 1
                            },
                            5000,
                            true
                        ).start();
                    }
                }
            }
        }
        return node;
    }
    _tempNode(x, y) {
        let me = this;

        let temp = new JTopo.CircleNode("连接点");
        temp.type = "temp";
        temp.fontColor = "0 0 0";
        temp.fillColor = "0 0 0";
        temp.setLocation(x, y);
        temp.radius = 8;

        temp.setFromline = function(line) {
            if (!this.fromlines) {
                this.fromlines = [];
            }
            this.fromlines.push(line);

            line.nodeZ = this;
        };
        temp.setToline = function(line) {
            if (!this.tolines) {
                this.tolines = [];
            }
            this.tolines.push(line);

            line.nodeA = this;
        };

        temp.addEventListener("mousedrag", function(e) {
            me.setState({ dragnode: this });
        });

        temp.addEventListener("mouseout", (e) => {
            // me.dragnode = undefined;
        });

        return temp;
    }
    _createMenu(id, items, node, event) {
        if (!items) {
            return;
        }
        let e = event || window.event;
        let me = this;
        let child = document.getElementById(id);
        if (child) {
            child.parentNode.removeChild(child);
        }

        let wrapUl = document.createElement("ul");
        wrapUl.setAttribute("id", id);
        wrapUl.setAttribute(
            "style",
            "position:fixed;top:" +
        e.clientY +
        "px;left:" +
        e.clientX +
        "px;width:110px;border-radius:3px;border:1px solid rgb(120, 120, 120);padding:0;margin:0;box-shadow:2px 2px 10px 0px rgb(200,200,200);font-size: 13px;"
        );
        for (let i = 0; i < items.length; i++) {
            if (node.type === STARTNODETYPE && items[i].pk >= "7") {
                continue;
            }
            if (node.type === "99" && items[i].pk < "7") {
                continue;
            }
            if (node.type === "02" && items[i].pk < "7") {
                continue;
            }
            if (typeof this.over !== "undefined" && items[i].pk === "6") {
                continue;
            }
            let item = document.createElement("li");
            item.setAttribute(
                "style",
                "list-style-type:none;width:110px;background-color:rgb(240,240,240);"
            );
            let inneritem = document.createElement("a");
            inneritem.onmouseover = function() {
                this.style.backgroundColor = "rgb(80,143,224)";
                this.style.color = "white";
            };
            inneritem.onmouseout = function() {
                this.style.backgroundColor = "rgb(240,240,240)";
                this.style.color = "";
            };
            inneritem.setAttribute(
                "style",
                "margin:0 auto;border-bottom:1px solid rgb(210, 210, 210);display:block;width:110px;padding:2px 0 2px 2px;fontSize:14px;font-weight:400;background-color:rgb(240,240,240);"
            );
            inneritem.innerHTML =
        "<img src='" +
        items[i].img +
        "' style='height:25px;width:25px'/>&nbsp;&nbsp;&nbsp;" +
        items[i].text;
            inneritem.func = items[i].func;
            inneritem.onclick = function() {
                this.func(me);
                me._hideMenu("ctxmenu");
            };
            item.appendChild(inneritem);
            wrapUl.appendChild(item);
        }
        document.body.appendChild(wrapUl);
    }
    _showMenu(node, id, event) {
    // let e = event || window.event;
        this._createMenu(id, this.state.contextmenu, node);
    }
    _hideMenu(id) {
        if (document.getElementById(id)) {
            document.getElementById(id).style.display = "none";
        }
    }
    /** *
   * 节点点击事件
   */
    rclickFunc(node) {
        this.setState({ currnode: node });
        this.setState({ currdata: node.data });
    }
    getNodeData(node, id) {
        if (node.data.id === id) {
            return node.data;
        }
        if (node.data.childNode) {
            for (let i = 0; i < node.data.childNode.length; i++) {
                let re = this.getNodeData(node.data.childNode[i]);
                if (re) {
                    return re;
                }
            }
        }
        return null;
    }
    setNodeData(data, id, node) {
        let nodeid;
        if (node === null) {
            node = this.state.root;
            nodeid = node.data.id;
        } else {
            nodeid = node.id;
        }
        if (nodeid === id) {
            node.data = data;
            return 0;
        }
        if (node.data.childNode) {
            for (let i = 0; i < node.data.childNode.length; i++) {
                let re = this.setNodeData(data, id, node.data.childNode[i]);
                if (re === 0) {
                    return re;
                }
            }
        }
        return 1;
    }
    clickFunc(node, wf) {
        wf.setState({ currnode: node });
        wf.setState({ currdata: node.data });
        if (node.type === "99") {
            return;
        }
        tool.setActiveWV("FLOWNodePanel", wf.state.objFct);
        wf.state.objFct.set("currenttype", node.type);
        wf.state.objFct.set("currentid", node.data.id);
        // let descript=wf.state.objFct.get("editGSconfig");
        // node.data=wf.getNodeData(descript,node.data.id);

        let inCondition = tool.getVal(node.data, "inConditionExp");
        let outCondition = tool.getVal(node.data, "outConditionExp");
        let inConditionCtl = tool.createElement(
            "SICondition",
            {
                key: tool.uuid(8),
                objFct: wf.state.objFct,
                moduleDesc: { cId: "inCondition" + node.type },
                contentStateToRowJson: inCondition
            },
            null,
            true
        );
        let outConditionCtl = tool.createElement(
            "SICondition",
            {
                key: tool.uuid(8),
                objFct: wf.state.objFct,
                moduleDesc: { cId: "outCondition" + node.type },
                contentStateToRowJson: outCondition
            },
            null,
            true
        );
        let inpanel, outpanel;
        // 显示编辑界面
        switch (node.type) {
            case STARTNODETYPE:
                // var editGSconfig=wf.state.objFct.get("editGSconfig");

                wf.state.objFct.set("StartNodeData", node.data);
                tool.setActiveWV("FlowStartNodePanel", wf.state.objFct);
                tool.refreshWV("StartNodeForm", wf.state.objFct);

                // tool.popUI(wf.state.uids[0], wf.state.objFct, "开始节点配置", 1024, 800);
                break;
            case "02":
                // name = "跳转节点";

                wf.state.objFct.set("JPNodeData", node.data);
                tool.setActiveWV("FlowJumpPanel", wf.state.objFct);
                tool.refreshWV("JPNodeForm", wf.state.objFct);

                inpanel = tool.getCmp("jumpinConditionPanel", wf.state.objFct);
                outpanel = tool.getCmp("jumpoutConditionPanel", wf.state.objFct);
                // tool.popUI(wf.state.uids[1], wf.state.objFct, "跳转节点配置", 1024, 800);
                break;
            case "03":
                // name = "服务节点";

                wf.state.objFct.set("SIMsgData", []);
                wf.state.objFct.set("SVData", []);
                wf.state.objFct.set("SVNodeMappingData", []);
                wf.state.objFct.set("SVNodeMappingData", node.data.SVNodeMappingData);
                wf.state.objFct.set("SVNodeData", node.data);
                var currentSVRoot = wf.state.objFct.get("currentSVRoot");

                let mconfig = tool.getVal(currentSVRoot, "cldSet");
                let data = [];
                let tmp = [];
                let flag = 1;

                mconfig.forEach((element) => {
                    if (element.cldSet) {
                        element.cldSet.forEach((cld) => {
                            cld.IO = element.iobType;
                            data.push(cld);
                        });
                    }
                });
                if (node.data.SVNodeMappingData) {
                    for (let j = 0; j < data.length; j++) {
                        flag = 1;
                        for (let i = 0; i < node.data.SVNodeMappingData.length; i++) {
                            if (data[j].code === node.data.SVNodeMappingData[i].SIBusKey && data[j].IO === node.data.SVNodeMappingData[i].IO) {
                                flag = 0;
                                break;
                            }
                        }
                        if (flag === 1) {
                            tmp.push(data[j]);
                        }
                    }
                    wf.state.objFct.set("SIMsgData", tmp);
                } else {
                    wf.state.objFct.set("SIMsgData", data);
                }
                tool.refreshTable("SIMsgTable", wf.state.objFct);

                if (node.data.serviceID) {
                    let callsi = PrmFactory.getPrm(node.data.serviceID);
                    let siconfig = tool.getVal(callsi, "cldSet");
                    let calldata = [];
                    let calldatatmp = [];
                    if (callsi.sitype == "03") {
                        siconfig.forEach((element) => {
                            let tmp = {
                                code: element.oKey,
                                nam: element.n,
                                IO: element.iobType,
                                ptn: element.desId
                            };
                            calldata.push(tmp);
                        });
                    }
                    if (callsi.sitype == "02") {
                        siconfig.forEach((element) => {
                            if (element.cldSet) {
                                element.cldSet.forEach((cld) => {
                                    cld.IO = element.iobType;
                                    calldata.push(cld);
                                });
                            }
                        });
                    }
                    if (node.data.SVNodeMappingData) {
                        for (let j = 0; j < calldata.length; j++) {
                            flag = 1;
                            for (let i = 0; i < node.data.SVNodeMappingData.length; i++) {
                                if (calldata[j].code === node.data.SVNodeMappingData[i].SVBusKey && calldata[j].IO === node.data.SVNodeMappingData[i].IO) {
                                    flag = 0;
                                    break;
                                }
                            }
                            if (flag === 1) {
                                calldatatmp.push(calldata[j]);
                            }
                        }
                        wf.state.objFct.set("SVData", calldatatmp);
                    } else {
                        wf.state.objFct.set("SVData", calldatatmp);
                    }
                    tool.refreshTable("SVTable", wf.state.objFct);
                }
                tool.setActiveWV("FlowServiceNodePanel", wf.state.objFct);
                tool.refreshTable("SVNodeMappingTable", wf.state.objFct);
                tool.refreshWV("SVNodeForm", wf.state.objFct);

                inpanel = tool.getCmp("servicesinConditionPanel", wf.state.objFct);
                outpanel = tool.getCmp("servicesoutConditionPanel", wf.state.objFct);
                // tool.popUI(wf.state.uids[2], wf.state.objFct, "服务节点配置", 1024, 800);
                break;
            case "04":
                // name = "脚本节点";

                wf.state.objFct.set("scriptcallinData", node.data.scriptcallin);
                wf.state.objFct.set("scriptcalloutData", node.data.scriptcallout);
                tool.refreshTable("scriptcallinTable", wf.state.objFct);
                tool.refreshTable("scriptcalloutTable", wf.state.objFct);
                wf.state.objFct.set("SCNodeData", node.data);
                tool.setActiveWV("FlowScriptNodePanel", wf.state.objFct);
                tool.refreshWV("SCNodeSCFrom", wf.state.objFct);

                tool.refreshWV("SCNodeForm", wf.state.objFct);
                // tool.popUI(wf.state.uids[3], wf.state.objFct, "脚本节点配置", 1024, 800);
                inpanel = tool.getCmp("scriptinConditionPanel", wf.state.objFct);
                outpanel = tool.getCmp("scriptoutConditionPanel", wf.state.objFct);
                break;
            case "05":
                // name = "子流程";
                wf.state.objFct.set("CLNodeData", node.data);
                tool.setActiveWV("FlowChildNodePanel", wf.state.objFct);
                tool.refreshWV("CLNodeForm", wf.state.objFct);
                inpanel = tool.getCmp("childinConditionPanel", wf.state.objFct);
                outpanel = tool.getCmp("childoutConditionPanel", wf.state.objFct);
                // tool.popUI(wf.state.uids[4], wf.state.objFct, "子流程节点配置", 1024, 800);
                break;
            case "99":
                // name = "结束";
                // tool.popUI(wf.state.uids[5], wf.state.objFct, "结束节点配置", 1024, 800);
                break;
            default:
                break;
        }
        inpanel.state.panelItems = [inConditionCtl];
        inpanel.setState({ loading: false });
        outpanel.state.panelItems = [outConditionCtl];
        outpanel.setState({ loading: false });

    // if (node.type !== STARTNODETYPE) wf.setState({ editpanelWidth: 18 });
    // else {
    //   wf.setState({ editpanelWidth: 24 });
    // }
    // wf.refs.NodeParaEditSD.showDrawer(node);
    }
    blankClickFunc() {
        this.setState({ currnode: null });
    // this.currnode = null;
    // this.refs.NodeParaEditSD.onClose();
    // this.dragnode =null;
    }
    rmenuClick(wf, type) {
        let node = wf.state.currnode;
        if (!node) {
            alert("no selected node");
            return;
        }

        if (type === "99" && typeof this.state.over !== "undefined") {
            alert("已有结束节点，请使用跳转节点结束流程");
            return;
        }

        let data = wf.newData(node, type);
        let nexnode = node.createNextNode(data);

        if (
            nexnode.parentsNode === null ||
      typeof nexnode.parentsNode === "undefined"
        ) {
            nexnode.parentsNode = [];
        }
        nexnode.parentsNode.push(node);
        if (!node.data.childNode) {
            node.data.childNode = [];
        }
        node.data.childNode.push(data);
        if (type === "02") {
            let chart = node.getChart();
            chart.jumpLine(nexnode);
        }
    }
    render() {
        return (
        // <div style={{ height:'790px',width: '100%' }} >
            <div
                ref="ServerInterface"
                style={{
                    height: this.state.h,
                    width: this.state.w,
                    border: 1,
                    borderStyle: "solid",
                    borderColor: "#DCDCDC"
                }}
            >
                <Row style={{ height: "100%", width: "100%" }}>
                    <Col span={this.state.editpanelWidth} style={{ height: "100%" }}>
                        <div
                            id={this.state.editid}
                            style={{
                                backgroundColor: "#FFFFFF",
                                height: "100%",
                                border: 1,
                                borderStyle: "solid",
                                borderColor: "#DCDCDC"
                            }}
                        >
                            <canvas
                                id={this.state.canvasid}
                                style={{ height: "100%", backgroundColor: "#FFFFFF" }}
                            >
                                {" "}
                            </canvas>
                        </div>
                    </Col>
                    <Col
                        span={24 - this.state.editpanelWidth}
                        style={{
                            height: "100%",
                            border: 1,
                            borderStyle: "solid",
                            borderColor: "#DCDCDC"
                        }}
                    >
                        {/* <NodeParaEditSD
              ref="NodeParaEditSD"
              node={this.state.currnode}
              nodedata={this.state.currdata}
            /> */}
                    </Col>
                </Row>
                {this.state.debug ? (
                    <Row style={{ height: "10%", width: "100%" }}>
                        <Button onClick={this.getData.bind(this)} type="primary">
              查看流程配置
                        </Button>
                        <Button>测试流程</Button>
                    </Row>
                ) : (
                    ""
                )}
            </div>
        );
    }
    componentDidMount() {
        let me = this;
        if (!me.state.canvas) {
            me.init();
        }
    }
    newData(node, type) {
        let x = 50;
        let y = 30;
        if (node) {
            x = node.x + 150;
            if (node.data.childNode) {
                y = node.y + node.data.childNode.length * 90;
            } else {
                y = node.y;
            }
        }

        let data = {
            id: this.maxid++,
            name: null,
            type: type,
            status: "00",
            ann: null,
            inCondition: null, // 准入条件
            outCondition: null, // 准出条件
            inConditionExp: null, // 准入条件表达式
            outConditionExp: null, // 准出条件表达式
            isfallback: "0", // 是否回退
            fallback: null, // 回退接口
            executionInterface: null, // 处理界面
            executionInterfaceparm: null, // 界面启动参数
            x: x,
            y: y,
            ishuman: "0",
            human: [],
            handling: []
        };
        if (type === STARTNODETYPE) {
            var me = this;
            var currentSVRoot = me.state.objFct.get("currentSVRoot");

            for (var attr in startNodedata) {
                data[attr] = startNodedata[attr];
                data.serviceID = currentSVRoot.guid;
                data.serviceUrl = currentSVRoot.url;
                data.servicetimeout = currentSVRoot.timeout;
                data.servicecalltype = "0";
            }
        }
        if (type === "03") {
            for (var attr in serviceNodedata) {
                data[attr] = serviceNodedata[attr];
            }
        }
        if (type === "04") {
            for (var attr in scriptNodedata) {
                data[attr] = scriptNodedata[attr];
            }
        }

        if (type === "99") {
            // 结束节点
            data.end = "0";
            data.endtype = "0";
            data.gototype = "0";
        }
        return data;
    }
    cvtToJson(root) {
        if (!root) {
            return;
        }
        let children = root.data.childNode;
        if (!children) {
            return;
        }
        for (let i = 0; i < children.length; i++) {
            let child = children[i].data;
            if (child.type === "06") {
                let array = [];
                let us = child.users;
                if (us) {
                    for (let j = 0; j < us.length; j++) {
                        let u = us[j];
                        array.push(u);
                    }
                    child.users = array;
                }
                let ps = child.posts;
                if (ps) {
                    array = [];
                    for (let j = 0; j < ps.length; j++) {
                        let p = ps[j];
                        array.push(p);
                    }
                    child.posts = array;
                }
            } else {
                continue;
            }
            this.cvtToJson(child);
        }
    }

    getJson(root) {
        if (!root) {
            root = this.state.root.data;
        }
        let json = {};
        json = root;
        let children = root.childNode;
        if (!children) {
            return json;
        }
        json.childNode = [];
        for (let i = 0; i < children.length; i++) {
            json.childNode.push(this.getJson(children[i]));
        }
        return json;
    }
    deleteEmptyProperty(object) {
        for (let i in object) {
            let value = object[i];
            if (typeof value === "object") {
                if (Array.isArray(value)) {
                    if (value.length === 0) {
                        delete object[i];
                        continue;
                    }
                }
                this.deleteEmptyProperty(value);
                if (this.isEmpty(value)) {
                    delete object[i];
                }
            } else if (value === "" || value === null || value === undefined) {
                delete object[i];
            } else {
            }
        }
    }

    isEmpty(object) {
        for (let name in object) {
            return false;
        }
        return true;
    }
    getData() {
        let json = this.getJson();
        // this.deleteEmptyProperty(json);
        Modal.info({
            title: "This is a notification message",
            content: JSON.stringify(json),
            onOk() {}
        });
    }
}

export default ServiceInterface;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/SIDef/ServiceInterface.js